// extracted by mini-css-extract-plugin
module.exports = {"jobs-overview-widget":"JobsOverviewWidget_jobs-overview-widget__FoQrV"};